import { cva } from "class-variance-authority";

import type { CaptainBalanceState } from "../balance-state";

export const balanceOrbitVariants = cva(
  "relative flex h-10 min-w-10 cursor-pointer items-center rounded-full border p-0 outline-none transition-[background-color,border-color,box-shadow] duration-200 ease-out focus-visible:ring-2 focus-visible:ring-ring motion-reduce:transition-none",
  {
    variants: {
      revealed: {
        true: "border-border bg-background-alt shadow-md dark:shadow-lg",
        false: "border-transparent bg-transparent",
      },
    },
  },
);

export const CAP_FILL: Record<CaptainBalanceState, string> = {
  healthy: "bg-primary",
  low: "bg-warning",
  usedUp: "bg-destructive",
};

export const TOP_UP_ARC = "stroke-chart-1";

export const ORBIT_TONE: Record<CaptainBalanceState, { arc: string; track: string; glyph: string; dot?: string }> = {
  healthy: { arc: "stroke-primary", track: "stroke-muted", glyph: "text-primary" },
  low: { arc: "stroke-warning", track: "stroke-muted", glyph: "text-warning", dot: "bg-warning" },
  usedUp: { arc: "stroke-transparent", track: "stroke-(--badge-error-border)", glyph: "text-destructive", dot: "bg-destructive" },
};
